import { Settings } from '@/store/module/setting';
import { RouteComponentProps } from 'react-router-dom';
import { UserState } from '@/store/module/user';

export interface LoginHistory {
  username: string | undefined;
  password: string;
  save?: boolean;
}

export interface LoginForm extends LoginHistory {
  autoLogin?: boolean;
  policy?: boolean;
}

export interface LoginProps extends RouteComponentProps {
  settings: Settings;
  updateLayoutSettings: (settings: Settings) => void;
  setUserInfo: (userInfo: UserState) => void;
}

export interface LuthInfoJson {
  account: string;
  loginAuthType: string;
  token: string;
  authOpenStatus: boolean;
}

export const LuthInfoData = {
  account: '',
  loginAuthType: '',
  token: '',
  authOpenStatus: false
};

export const LOGIN_HISTORY_KEY = 'temp';

export const REPORTED_KEY = 'SEOINFORMATION';

/** 登录页记录的来源标识（与 hisId 解析一致），用于上报判断 */
export const LOGIN_TRAFFIC_SOURCE_KEY = 'loginTrafficSource';
/** reportedId !== '1' */
export const LOGIN_SOURCE_BAIDULK = 'baidulk';
export const LOGIN_SOURCE_MSCLK = 'msclk';
export const LOGIN_SOURCE_YKLK = 'yklk';
export const LOGIN_SOURCE_SOUGOULK = 'sougoulk';
/** paramArr[1] 非 msclk/yklk/sougoulk 且 reportedId === '1' */
export const LOGIN_SOURCE_360LK = '360lk';

/** 本机上次登录成功日历日 YYYY-MM-DD */
export const LOGIN_LAST_LOCAL_DAY_KEY = 'loginLastLocalDay';
/** 本机是否已打过次留 RETENTION（只在本机记一次） */
export const LOGIN_RETENTION_REPORTED_KEY = 'loginRetentionReported';
/** 360 推广参数缓存（sourceId/token/secret/jzqs/idx） */
export const LOGIN_360_PROMOTION_PARAMS_KEY = 'login360PromotionParams';

export const approveList = [
  '经系统检测，该账号首次登录此设备，请输入手机验证码进行验证或在原登录手机点击通过进行登录',
  '经系统检测，该账号已超过30天未登录，为保证您的账号安全，请输入手机验证码进行验证',
  '经系统检测，该账号为引擎账号首次登录盒子，为保证您的账号安全，请输入手机验证码进行验证',
  '请在原设备点击授权登录',
  '经系统检测，该账号首次登录此设备，请输入手机验证码进行验证'
];

// let wsUrl: string = '';
// const NODE_ENV = process.env.REACT_APP_ENV;
// const envConfig: string | undefined = process.env.NODE_ENV === 'development' ? 'test' : NODE_ENV; // 开发环境  和  发布环境
// if (envConfig === 'development') wsUrl = 'ws://test-api.996box.com';
// if (envConfig === 'test') wsUrl = 'ws://test-api.996box.com';
// if (envConfig === 'pre') wsUrl = 'wss://pre-ws.996box.com';
// if (envConfig === 'production') wsUrl = 'wss://ws.996box.com';
// wsUrl = 'wss://pre-ws.996box.com';
// export const Websocket_key = wsUrl;
